import { FacetNavigationEntry } from '@/components/content/FacetNavigation/parts/Entry';
import { facetNavigationGridItemSX } from '@/components/content/FacetNavigation/styles/gridItem';
import { useFacetNavigation } from '@/data/Content/FacetNavigation';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { ProductFacet } from '@/data/types/Product';
import { ProductFacetEntry } from '@/data/types/Product';
import { Button, Grid, Stack } from '@mui/material';
import { FC, useContext, useState } from 'react';

type props = {
	facetItem: ProductFacet & { showMore: boolean; showLess: boolean };
	visibleEntries: Record<string, ProductFacetEntry[]>;
};

const LIMIT_FACETS = 10;

export const FacetNavigationFacetElement: FC<props> = ({ facetItem, visibleEntries }) => {
	const productFilterNLS = useLocalization('ProductFilter');
	const { toggleFacetLimit } = useContext(ContentContext) as ReturnType<typeof useFacetNavigation>;
	const { value, name, showLess, showMore, entry } = facetItem;
	const isAllValues = showLess === showMore;
	const isAllValuesButton = isAllValues && visibleEntries[value]?.length > LIMIT_FACETS;
	const [limit, setLimit] = useState(LIMIT_FACETS);
	const isMoreThanLimit = limit >= Number(visibleEntries[value]?.length);
	const toggleShow = () => {
		setLimit(isMoreThanLimit ? LIMIT_FACETS : visibleEntries[value]?.length);
	};
	return (
		<Stack justifyContent="flex-start" alignItems="flex-start">
			<Grid>
				{visibleEntries[value]?.slice(0, isAllValues ? limit : undefined).map((entry) => (
					<Grid
						item
						key={entry.value}
						sx={facetNavigationGridItemSX(!entry.image)}
						className="product-filter__option"
					>
						<FacetNavigationEntry entry={entry} facetValue={value} />
					</Grid>
				))}
			</Grid>
			{entry ? (
				isAllValuesButton ? (
					<Button
						variant="inline"
						data-testid={`productFilter_${name}_show_more`}
						id={`productFilter_${name}_show_more`}
						onClick={toggleShow}
					>
						{isMoreThanLimit
							? productFilterNLS.Actions.showLess.t()
							: productFilterNLS.Actions.showMore.t()}
					</Button>
				) : showMore || showLess ? (
					<Button
						variant="inline"
						data-testid={`productFilter_${name}_show_more`}
						id={`productFilter_${name}_show_more`}
						onClick={toggleFacetLimit(value)}
					>
						{showMore
							? productFilterNLS.Actions.showMore.t()
							: productFilterNLS.Actions.showLess.t()}
					</Button>
				) : null
			) : null}
		</Stack>
	);
};
